/* ============================================================
   AVORA SEARCH — Immersive Glass Discovery
   Scroll-reveal · department navigation · search interactions
   ============================================================ */

(function () {
  'use strict';

  var STAGGER_MS = 80;
  var BATCH_DELAY_MS = 40;

  /* ── 1. Scroll Reveal for Product Cards ── */

  function initCardReveals() {
    var grid = document.querySelector('.avora-search-results .product-grid');
    if (!grid) return;

    var pendingBatch = [];
    var batchTimer = null;

    function flushBatch() {
      var batch = pendingBatch.splice(0);
      batch.forEach(function (card, i) {
        card.style.setProperty('--reveal-delay', i * STAGGER_MS + 'ms');
        card.classList.add('is-revealed');
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var any = false;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            any = true;
            pendingBatch.push(entry.target);
            observer.unobserve(entry.target);
          }
        });
        if (any) {
          clearTimeout(batchTimer);
          batchTimer = setTimeout(flushBatch, BATCH_DELAY_MS);
        }
      },
      { threshold: 0.08, rootMargin: '60px' }
    );

    function observeNewCards() {
      grid.querySelectorAll('.product-grid__item:not(.is-revealed):not(.is-observing)').forEach(function (card) {
        card.classList.add('is-observing');
        observer.observe(card);
      });
    }

    observeNewCards();
    new MutationObserver(observeNewCards).observe(grid, { childList: true });
  }

  /* ── 2. Department Navigation ── */

  function initDepartmentNav() {
    var nav = document.querySelector('.avora-search-depts');
    if (!nav) return;

    var pills = nav.querySelectorAll('.avora-search-dept__pill[data-dept]');
    var openIndex = null;

    /* ── Scroll arrows ── */
    var scrollEl = nav.querySelector('.avora-search-depts__strip');
    var scrollWrap = nav.querySelector('.avora-search-depts__scroll');
    var arrowL = nav.querySelector('.avora-search-depts__arrow--left');
    var arrowR = nav.querySelector('.avora-search-depts__arrow--right');

    if (scrollEl && arrowL && arrowR) {
      function updateArrows() {
        var sl = scrollEl.scrollLeft;
        var max = scrollEl.scrollWidth - scrollEl.clientWidth;
        if (sl > 8) {
          arrowL.removeAttribute('hidden');
          if (scrollWrap) scrollWrap.classList.add('has-scroll-left');
        } else {
          arrowL.setAttribute('hidden', '');
          if (scrollWrap) scrollWrap.classList.remove('has-scroll-left');
        }
        if (sl >= max - 8) {
          if (scrollWrap) scrollWrap.classList.add('no-scroll-right');
        } else {
          if (scrollWrap) scrollWrap.classList.remove('no-scroll-right');
        }
      }

      arrowL.addEventListener('click', function () {
        scrollEl.scrollBy({ left: -220, behavior: 'smooth' });
      });
      arrowR.addEventListener('click', function () {
        scrollEl.scrollBy({ left: 220, behavior: 'smooth' });
      });

      scrollEl.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = pill.getAttribute('data-dept');

        if (openIndex === idx) {
          /* Close current */
          closePanel(idx);
          pill.setAttribute('aria-expanded', 'false');
          openIndex = null;
          return;
        }

        /* Close previous */
        if (openIndex !== null) {
          closePanel(openIndex);
          var prevPill = nav.querySelector('.avora-search-dept__pill[data-dept="' + openIndex + '"]');
          if (prevPill) prevPill.setAttribute('aria-expanded', 'false');
        }

        /* Open new */
        openPanel(idx);
        pill.setAttribute('aria-expanded', 'true');
        openIndex = idx;
      });
    });

    function openPanel(idx) {
      var panel = nav.querySelector('.avora-search-subcats[data-dept-panel="' + idx + '"]');
      if (!panel) return;
      panel.removeAttribute('hidden');
      /* Force reflow before adding class */
      panel.offsetHeight;
      panel.classList.add('is-open');
    }

    function closePanel(idx) {
      var panel = nav.querySelector('.avora-search-subcats[data-dept-panel="' + idx + '"]');
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.addEventListener('transitionend', function handler() {
        if (!panel.classList.contains('is-open')) {
          panel.setAttribute('hidden', '');
        }
        panel.removeEventListener('transitionend', handler);
      });
    }
  }

  /* ── 3. Hide Redundant Filters ── */

  function hideRedundantFilters() {
    var labels = document.querySelectorAll('.avora-search-results .facets__label');
    var hideList = ['availability', 'product type', 'subcategory', 'disponibilité', 'type de produit', 'sous-catégorie'];

    labels.forEach(function (label) {
      var text = label.textContent.trim().toLowerCase();
      if (hideList.indexOf(text) !== -1) {
        var item = label.closest('.facets__item') || label.closest('details') || label.closest('accordion-custom');
        if (item) item.style.display = 'none';
      }
    });

    /* Hide grid density controls */
    document.querySelectorAll('.avora-search-results input[type="radio"][name="grid"], .avora-search-results input[type="radio"][name="grid-mobile"]').forEach(function (input) {
      input.style.display = 'none';
      var label = input.nextElementSibling || document.querySelector('label[for="' + input.id + '"]');
      if (label) label.style.display = 'none';
    });
    document.querySelectorAll('.avora-search-results .facets__grid-density, .avora-search-results [class*="grid-density"], .avora-search-results [class*="grid-toggle"]').forEach(function (el) {
      el.style.display = 'none';
    });

    /* Also observe for AJAX re-renders */
    var facetsWrapper = document.querySelector('.avora-search-results .facets--horizontal');
    if (facetsWrapper) {
      new MutationObserver(function () {
        var newLabels = facetsWrapper.querySelectorAll('.facets__label');
        newLabels.forEach(function (label) {
          var text = label.textContent.trim().toLowerCase();
          if (hideList.indexOf(text) !== -1) {
            var item = label.closest('.facets__item') || label.closest('details') || label.closest('accordion-custom');
            if (item) item.style.display = 'none';
          }
        });
        /* Re-hide grid controls after AJAX */
        facetsWrapper.querySelectorAll('input[type="radio"][name="grid"], input[type="radio"][name="grid-mobile"]').forEach(function (input) {
          input.style.display = 'none';
          var label = input.nextElementSibling || document.querySelector('label[for="' + input.id + '"]');
          if (label) label.style.display = 'none';
        });
        facetsWrapper.querySelectorAll('[class*="grid-density"], [class*="grid-toggle"]').forEach(function (el) {
          el.style.display = 'none';
        });
      }).observe(facetsWrapper, { childList: true, subtree: true });
    }
  }

  /* ── 4. Search Shimmer on Submit ── */

  function initSearchShimmer() {
    var form = document.querySelector('.avora-search-hero form[role="search"]');
    if (!form) return;
    form.addEventListener('submit', function () {
      var comp = form.querySelector('search-page-input-component');
      if (comp) comp.classList.add('is-loading');
    });
  }

  /* ── 4. Reduced Motion ── */

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ── Init ── */

  function init() {
    initDepartmentNav();
    hideRedundantFilters();
    initSearchShimmer();

    if (prefersReducedMotion()) {
      document.querySelectorAll('.avora-search-results .product-grid__item').forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    initCardReveals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
